import useToReceiveCrossdockingFromWarecloud from './useToReceiveCrossdockingFromWarecloud';

export default function useToReceiveCrossdockingActions() {
  const {
    mutate: toReceiveCrossdockingFromWarecloud,
    isPending: isLoadingToReceiveCrossdockingFromWarecloud,
  } = useToReceiveCrossdockingFromWarecloud();

  const onCodeScanned = (scanValue) => {
    toReceiveCrossdockingFromWarecloud({
      scanValue,
      scanFromBarcode: true,
    });
  };

  const onManualDelivery = (scanValue) => {
    toReceiveCrossdockingFromWarecloud({
      scanValue,
      scanFromBarcode: false,
    });
  };

  return {
    onCodeScanned,
    onManualDelivery,
    isLoadingToReceiveCrossdockingFromWarecloud,
  };
}
